import React, { createContext, useContext, useState } from "react";
import BackdropFSLoader from "../components/Common/BackdropFSLoader";
import BackdropFSTextLoaderGreen from "../components/Common/BackdropFSTextLoaderGreen";
import SuccessPopupGreen from "../components/Common/SuccessPopupGreen";
import { useDispatch } from "react-redux";
import { clearAuthUser } from "../redux/slice/AuthSlice";
import { persistor } from "..";
import { useNavigate } from "react-router-dom";
import { useSocketContext } from "./SocketContext";
import SuccessPopupBlue from "../components/Common/SuccessPopupBlue";

// Creating a context
const PicContext = createContext({
  theme: [],
  setTheme: () => {},
  setIsLoading: () => {},
  setIsLoadingText: () => {},
  setSuccessPopup: () => {},
  handleLogout: () => {},
  setSuccessPopupBlue: () => {},
  searchQuery: "",
  setSearchQuery: () => {},
  currentPage: "",
  setCurrentPage: () => {},
  showSearch: false,
  setShowSearch: () => {},
  searchPlaceholder: "Search",
  setSearchPlaceholder: () => {},
});

const successPopupInitial = {
  open: false,
  message: "",
  title: "",
  primaryText: "Done",
  secondaryText: "Cancel",
  primaryURL: "",
  secondaryURL: "",
  child: null,
};

const successPopupInitialBlue = {
  open: false,
  message: "",
  primaryURL: "",
  secondaryURL: "",
  handleCloseSuccessPopup: () => {},
  primaryText: "",
  secondaryText: "",
  title: "",
  child: null,
};

// A component that provides the theme
export const PicProvider = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [theme, setTheme] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingText, setIsLoadingText] = useState(false);
  const [successPopup, setSuccessPopup] = useState(successPopupInitial);
  const [successPopupBlue, setSuccessPopupBlue] = useState(
    successPopupInitialBlue
  );
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [showSearch, setShowSearch] = useState(false);
  const [searchPlaceholder, setSearchPlaceholder] = useState("");
  const { handleDisconnectSocket } = useSocketContext();
  const handleCloseSuccessPopup = () => setSuccessPopup(successPopupInitial);
  const handleCloseSuccessBluePopup = () =>
    setSuccessPopupBlue(successPopupInitialBlue);
  const handleLogout = async () => {
    await dispatch(clearAuthUser());
    await dispatch({ type: "RESET_APP" });
    await persistor.purge();
    await handleDisconnectSocket();
    await navigate("/login");
  };

  return (
    <PicContext.Provider
      value={{
        theme,
        setTheme,
        setIsLoading,
        setIsLoadingText,
        setSuccessPopup,
        handleLogout,
        setSuccessPopupBlue,
        searchQuery,
        setSearchQuery,
        currentPage,
        setCurrentPage,
        showSearch,
        setShowSearch,
        searchPlaceholder,
        setSearchPlaceholder,
      }}
    >
      <BackdropFSLoader open={isLoading} />
      <BackdropFSTextLoaderGreen open={isLoadingText} />
      <SuccessPopupGreen
        open={successPopup.open}
        primaryURL={successPopup.primaryURL}
        secondaryURL={successPopup.secondaryURL}
        message={successPopup.message}
        handleCloseSuccessPopup={handleCloseSuccessPopup}
        primaryText={successPopup.primaryText}
        secondaryText={successPopup.secondaryText}
        title={successPopup.title}
        child={successPopup.child}
      />
      <SuccessPopupBlue
        open={successPopupBlue.open}
        message={successPopupBlue.message}
        handleCloseSuccessPopup={handleCloseSuccessBluePopup}
        primaryURL={successPopupBlue.primaryURL}
        secondaryURL={successPopupBlue.secondaryURL}
        primaryText={successPopupBlue.primaryText}
        secondaryText={successPopupBlue.secondaryText}
        title={successPopupBlue.title}
        child={successPopupBlue.child}
      />
      {children}
    </PicContext.Provider>
  );
};

// A custom hook to consume the theme context
export const usePic = () => useContext(PicContext);
